import { CartItem } from '@guest-widgets/shared/src/types/product/cartItem';
import { UpsellItem as UpsellItemType } from '@guest-widgets/shared/src/types/product/upsellItem';

import { isUpsellItem } from '../../common/typeGuards';

import { UpsellInCart } from './UpsellInCart';
import { SingleQty } from './SingleQty';
import { BaseUpsellItem } from './BaseUpsell';
import { RequiredInheritedHandler } from './RequiredInheritedHandler';

interface ItemUpsellPriceProps {
  item: UpsellItemType | CartItem;
}

export const UpsellItem = ({ item }: ItemUpsellPriceProps) => {
  if (!isUpsellItem(item)) {
    return <UpsellInCart item={item} />;
  }
  const { uiSelectors, sameParentQuantity, isRequired } = item.configuration;

  if (sameParentQuantity || isRequired) {
    return <RequiredInheritedHandler item={item} />;
  }

  if (uiSelectors.drawerLayout == 'singleQty') {
    return <SingleQty item={item} />;
  }

  return <BaseUpsellItem item={item} />;
};
